import React from 'react';

import { imgPath } from '~common/utilities/ImgUrl';
import { Messages } from '~src/codegen/Localize';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';

import { CollectionPrivateHeader } from './CollectionSpace';

export const CollectionsPrivateIndicatorIdPrefix = 'collections-private-indicator';
export function CollectionsCardPrivateIndicator() {
    return (
        <div className={CardViewStyles.PrivateCollectionArea}>
            <img src={imgPath('lock_locked_14px-small.svg')} alt='' />
            <span className={CardViewStyles.PrivateCollectionText}>{Messages.collectionVisibilityPrivate()}</span>
      </div>
    );
}

const LOCKED_IMG = imgPath('lock_locked_14px-small.svg');

// Used for collection space header and list view
export function CollectionsPrivateIndicator() {
  return (
    <div data-tb-test-id={CollectionPrivateHeader}>
      <img src={LOCKED_IMG} alt='' />
      <span style={{ marginLeft: 2 }}>{Messages.collectionVisibilityPrivate()}</span>
    </div>
  );
}
